// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2NEvy","large":"styles_large__1yz_s"};